export default __webpack_public_path__ + "static/media/Earthwrack.43a68cc1.jpg";